import React from 'react';
import './ForbidentView.scss';
import { LANDING_PAGE_ROUTE, PORTAL_ROUTE } from 'config/route-consts';
import { useTranslation } from 'react-i18next';

function ForbidentView() {
  const [translate] = useTranslation();

  const handleClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    window.location.href = PORTAL_ROUTE;
  };

  const handleBackLanding = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    window.location.href = LANDING_PAGE_ROUTE;
  };


  return (
    <div className="forbident-page">
      <div className="logo"></div>
      <h1 className="forbident-page__title mt-5">{translate('forbidden.title.accessRestricted')}</h1>
      <p className="forbident-page__content mt-5">
        {translate('forbidden.content.pleaseContact')}
        <a href="mailto:servicedesk@maisonrmi.com"
        className="forbident-page__contact">
          {' servicedesk@maisonrmi.com '}
        </a>
        {translate('forbidden.content.forAssistance')}
      </p>

      <div className="forbident-page__actions mt-5">
        <button className="btn mr-2" onClick={handleClick}>
          <span>
            <i className="tio-back_ui"></i> Go Back
          </span>
        </button>
        <button className="btn mr-2" onClick={handleBackLanding}>
          <span>
            <i className="tio-back_ui"></i> Back to Landing Page
          </span>
        </button>
      </div>
    </div>
  );
}

export default ForbidentView;
